import { generateUtilityClass, generateUtilityClasses } from '@mui/base';
export function getFabUtilityClass(slot) {
  return generateUtilityClass('MuiFab', slot);
}
const fabClasses = generateUtilityClasses('MuiFab', ['root', 'primary', 'secondary', 'extended', 'circular', 'focusVisible', 'disabled', 'colorInherit', 'sizeSmall', 'sizeMedium', 'sizeLarge', 'info', 'error', 'warning', 'success']);
export default fabClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/Fab/fabClasses.js
// module id = 303
// module chunks = 1